import { NavLink } from '../NavLink';

export const SetupGuideNavigationItem = ({ href }) => {
  if (!href) {
    return null;
  }

  return (
    <NavLink href={href} iconName="clipboard" activePaths={[href]}>
      راهنمای راه‌اندازی
    </NavLink>
  );
};